import { render, staticRenderFns } from "./itemsList.vue?vue&type=template&id=2852dcb3"
import script from "./itemsList.vue?vue&type=script&lang=js"
export * from "./itemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports